import MuiButton from './MuiButton';
import MuiDataGrid from './MuiDataGrid';
import MuiDialog from './MuiDialog';
import MuiGrid from './MuiGrid';
import MuiIconButton from './MuiIconButton';
import MuiLink from './MuiLink';
import MuiSvgIcon from './MuiSvgIcon';
import MuiRadio from './MuiRadio';
import MuiSelect from './MuiSelect';
import MuiStack from './MuiStack';
import MuiSwitch from './MuiSwitch';
import MuiTextField from './MuiTextField';
import MuiToolbar from './MuiToolbar';
import MuiTypography from './MuiTypography';

const itauComponents = {
  MuiButton,
  MuiDataGrid,
  MuiDialog,
  MuiGrid,
  MuiIconButton,
  MuiLink,
  MuiRadio,
  MuiSelect,
  MuiStack,
  MuiSvgIcon,
  MuiSwitch,
  MuiTextField,
  MuiToolbar,
  MuiTypography,
};

export default itauComponents;
